import { Grid } from '@mui/material';
import { GridDirection, GridProps } from '@mui/material/Grid/Grid';
import type { ResponsiveStyleValue } from '@mui/system';
import React from 'react';

type GridItemProps = Pick<
  GridProps,
  'children' | 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'container' | 'sx' | 'spacing' | 'columns'
>;

const GridItem: React.FC<GridItemProps> = ({
  children,
  xs = 1,
  sm,
  md,
  lg,
  xl,
  container = false,
  sx,
  spacing,
  columns,
}) => {
  let direction: ResponsiveStyleValue<GridDirection> | undefined;
  let justifyContent;
  let alignItems;

  if (container) {
    direction = 'row';
    justifyContent = 'center';
    alignItems = 'stretch';
  }
  return (
    <Grid
      item
      container={container}
      xs={xs}
      sm={sm}
      md={md}
      lg={lg}
      xl={xl}
      direction={direction}
      justifyContent={justifyContent}
      alignItems={alignItems}
      sx={sx}
      spacing={spacing}
      columns={columns}
    >
      {children}
    </Grid>
  );
};

export { GridItem as default, GridItem };
export type { GridItemProps };
